import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'timetable/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('timetable/', '')
      .toLowerCase();
  }
}
